import { TYPE_KEY } from "../common/constant";
import { coalesce } from "../utils/ObjectUtils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";

const SHOW_CONFIRM_DIALOG_ACTION = "SHOW_CONFIRM_DIALOG_ACTION";
const HIDE_CONFIRM_DIALOG_ACTION = "HIDE_CONFIRM_DIALOG_ACTION";

export const DIALOG_SHOW = "show";
export const DATA = "data";
export const ON_CONFIRM_DIALOG = "onConfirmDialog";
export const DIALOG_TITLE = "dialogTitle";
export const DIALOG_TEXT = "dialogText";
export const CONFIRM_LABEL = "confirmLabel";
export const DISMISS_LABEL = "dismissLabel";
export const ICON = "icon";
export const SPECIAL_CANCEL_FUNCTION = "specialCancelFunction";

const initialState = {
  [DIALOG_SHOW]: false,
  [DATA]: null,
  [ON_CONFIRM_DIALOG]: null,
  [DIALOG_TITLE]: "",
  [DIALOG_TEXT]: "confirmDialog.text",
  [CONFIRM_LABEL]: "confirmDialog.confirmLabel",
  [DISMISS_LABEL]: "confirmDialog.dismissLabel",
  [ICON]: <FontAwesomeIcon icon={faExclamationTriangle} size={"2x"} />,
  [SPECIAL_CANCEL_FUNCTION]: null
};

export default function reducer(state = initialState, action) {
  let newState;
  switch (action[TYPE_KEY]) {
    case SHOW_CONFIRM_DIALOG_ACTION:
      newState = Object.assign({}, state, {
        [DIALOG_SHOW]: true,
        [DATA]: action[DATA],
        [ON_CONFIRM_DIALOG]: action[ON_CONFIRM_DIALOG],
        [DIALOG_TITLE]: action[DIALOG_TITLE],
        [DIALOG_TEXT]: action[DIALOG_TEXT],
        [CONFIRM_LABEL]: action[CONFIRM_LABEL],
        [DISMISS_LABEL]: action[DISMISS_LABEL],
        [ICON]: action[ICON],
        [SPECIAL_CANCEL_FUNCTION]: coalesce(action[SPECIAL_CANCEL_FUNCTION], state[SPECIAL_CANCEL_FUNCTION])
      });
      break;
    case HIDE_CONFIRM_DIALOG_ACTION:
      newState = Object.assign({}, state, {
        [DIALOG_SHOW]: false,
        [DATA]: null,
        [ON_CONFIRM_DIALOG]: null,
        [DIALOG_TITLE]: "confirmDialog.title",
        [DIALOG_TEXT]: "confirmDialog.text",
        [CONFIRM_LABEL]: "confirmDialog.confirmLabel",
        [DISMISS_LABEL]: "confirmDialog.dismissLabel",
        [ICON]: null,
        [SPECIAL_CANCEL_FUNCTION]: null
      });
      break;
    default:
      newState = Object.assign({}, state, {});
      break;
  }
  return newState;
}

/**
 * Show Dialog Action
 */
export function showDialog(
  data,
  onConfirmDialog,
  title,
  text,
  confirmLabel,
  dismissLabel,
  icon,
  specialCancelFunction
) {
  return (dispatch) => {
    dispatch({
      [TYPE_KEY]: SHOW_CONFIRM_DIALOG_ACTION,
      [DATA]: data,
      [ON_CONFIRM_DIALOG]: onConfirmDialog,
      [DIALOG_TITLE]: title,
      [DIALOG_TEXT]: text,
      [CONFIRM_LABEL]: confirmLabel,
      [DISMISS_LABEL]: dismissLabel,
      [ICON]: icon,
      [SPECIAL_CANCEL_FUNCTION]: specialCancelFunction
    });
  };
}

/**
 * Hide Dialog Action
 */
export function hideDialog() {
  return (dispatch) => {
    dispatch({
      [TYPE_KEY]: HIDE_CONFIRM_DIALOG_ACTION
    });
  };
}
